import { CreditProps } from "../components/common/generalPickersBlocks/credits/CreditsPickerComponent";
import { DiscountProps } from "../types/generalDiscount";

export const sortByCount = (array: Array<CreditProps>) => {
    const arrCopy = [...array];
    return arrCopy.sort((a, b) => +a.count > +b.count || +a.count === +b.count ? 1 : -1);
}
export const sortByAmountTickets = (array: Array<DiscountProps>) => {
    const arrCopy = [...array];
    return arrCopy.sort((a, b) => +a.amountTickets > +b.amountTickets || +a.amountTickets === +b.amountTickets ? 1 : -1);
}
export const foundSameCount = (array: Array<CreditProps>) => {
    if (!array) {
        return new Array<CreditProps>()
    }
    let duplicates: Array<number> = []
    const arrOfCounts = array.map((i) => i.count);
    const tempSortedArrayOfCounts = [...arrOfCounts].sort()

    for (let index = 0; index < tempSortedArrayOfCounts.length; index++) {
        if (tempSortedArrayOfCounts[index + 1] === tempSortedArrayOfCounts[index]) {
            duplicates.push(tempSortedArrayOfCounts[index])
        }
    }
    return duplicates;
}

export const foundSameTicketsAmount = (array: Array<DiscountProps>) => {
    let duplicates: Array<number> = []
    const arrOfCounts = array.map((i) => i.amountTickets);
    const tempSortedArrayOfCounts = [...arrOfCounts].sort()

    for (let index = 0; index < tempSortedArrayOfCounts.length; index++) {
        if (tempSortedArrayOfCounts[index + 1] === tempSortedArrayOfCounts[index]) {
            duplicates.push(tempSortedArrayOfCounts[index])
        }
    }
    return duplicates;
}